module.exports = __webpack_public_path__ + "img/puroak.icon.assurance.asset.22bef17b.svg";